export default {
  InactiveColumn: {
    True: "Ngừng kích hoạt",
    False: "Đang sử dụng"
  },
  ProxyStatusColumn: {
    True: "Được phép sử dụng",
    False: "Không được sử dụng"
  }
};
